
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Alert, ALERT_TYPE } from '../../../../../components/alert/alert.model';
import { ModalService } from '../../../../../components/modal-list/modal-list.service';
import { ApprovalsPageService } from '../../_core/approvals-page.service';
import { ToasterService } from '../../../../../components/toaster/toaster.service';
import {
  REQUEST_TYPE,
  REPLY_REQUEST,
  Requisition,
  RequistionDetailsRequest,
  REQUEST_STATUS,
  ReplyConfig,
} from '../../_core/approvals-page.model';
import { loadingStatus } from '../../../../../core/models/request-status.model';

@Component({
  selector: 'modal-request-details-base',
  standalone: true,
  imports: [],
  templateUrl: './modal-request-details-base.component.html',
  styleUrl: './modal-request-details-base.component.scss',
})
export class ModalRequestDetailsBaseComponent implements OnInit, OnDestroy {
  @Input() data!: {
    requisition: Requisition;
    onUpdate: () => void;
  };

  REQUEST_STATUS = REQUEST_STATUS;
  REQUEST_TYPE = REQUEST_TYPE;
  REPLY_REQUEST = REPLY_REQUEST;
  subscription = new Subscription();
  requisitionDetailsRequest$ = new BehaviorSubject<RequistionDetailsRequest>({});

  alertMessage: Alert = {
    isActive: true,
    title: '',
    content: '',
    containerClass: '',
    hasCloseButton: false,
    type: ALERT_TYPE.DANGER,
  };

  constructor(
    protected toasterService: ToasterService,
    protected modalService: ModalService,
    protected approvalsPageService: ApprovalsPageService,
    protected cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getRequisitionDetails();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getRequisitionDetails() {
    const code = this?.data?.requisition?.code;

    if (!code) {
      this.toasterService.displayError('Error: No code provided');
      this.modalService.close();
      return;
    }

    this.requisitionDetailsRequest$.next(loadingStatus);

    this.subscription.add(
      this.approvalsPageService.getRequestDetails(code).subscribe(response => {
        if (response.hasError) {
          this.alertMessage.content = response.message;
        }

        this.requisitionDetailsRequest$.next(response);
        this.cdr.detectChanges();
      }),
    );
  }

  close() {
    this.modalService.close();
  }

  reply(replyConfig: ReplyConfig) {
    this.subscription.add(
      this.approvalsPageService.replyRequest(replyConfig).subscribe(response => {
        if (response.hasError || !response.hasUpdated) {
          this.toasterService.displayError(response.message!);
          return;
        }

        if (replyConfig.status === REPLY_REQUEST.APPROVE) {
          this.toasterService.displaySuccess('Approved Successfully.');
        }

        if (replyConfig.status === REPLY_REQUEST.REPROVE) {
          this.toasterService.displaySuccess('Denied Successfully.');
        }

        this.modalService.close();
        this.data.onUpdate && this.data.onUpdate();
      }),
    );
  }
}
